/* SH Checkout Confirmation Modal */

// Only intercept the checkout button specifically
function interceptCheckoutClick(e) {
  console.log('[MODAL] interceptCheckoutClick fired', { eventType: e.type, target: e.target });

  // Only intercept if clicking the checkout modal button
  const target = e.target.closest('.js-show-checkout-modal');
  console.log('[MODAL] Closest .js-show-checkout-modal found:', target);

  if (target) {
    console.log('[MODAL] Target matched! Preventing default and showing modal');
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Manually trigger the modal
    const modal = document.querySelector('sh-checkout-confirmation-modal');
    console.log('[MODAL] Modal element found:', modal);
    console.log('[MODAL] Modal has showModal method:', modal && modal.showModal);

    if (modal && modal.showModal) {
      console.log('[MODAL] Calling modal.showModal()');
      modal.showModal();
    } else {
      console.warn('[MODAL] Could not show modal - element or method missing');
    }
    return false;
  }
  // If not the checkout button, let the click through normally
}

// Add listeners with capture phase to intercept before third-party scripts
// Using multiple event types to ensure we catch the interaction
document.addEventListener('click', interceptCheckoutClick, { capture: true, passive: false });
document.addEventListener('mousedown', interceptCheckoutClick, { capture: true, passive: false });
document.addEventListener('touchstart', interceptCheckoutClick, { capture: true, passive: false });

// Additional safety: Direct click handler on the button after DOM is ready
function attachDirectHandler() {
  console.log('[MODAL] attachDirectHandler called');
  const button = document.querySelector('.js-show-checkout-modal');
  console.log('[MODAL] Button found:', button);
  console.log('[MODAL] Button has data-modal-attached:', button && button.hasAttribute('data-modal-attached'));

  if (button && !button.hasAttribute('data-modal-attached')) {
    console.log('[MODAL] Attaching direct handler to button');
    button.setAttribute('data-modal-attached', 'true');
    button.addEventListener('click', (e) => {
      console.log('[MODAL] Direct handler clicked!');
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const modal = document.querySelector('sh-checkout-confirmation-modal');
      console.log('[MODAL] Direct handler - Modal found:', modal);
      if (modal && modal.showModal) {
        console.log('[MODAL] Direct handler - Calling showModal()');
        modal.showModal();
      } else {
        console.warn('[MODAL] Direct handler - Modal or showModal method not found');
      }
      return false;
    }, { capture: true });
    console.log('[MODAL] Direct handler attached successfully');
  } else if (button) {
    console.log('[MODAL] Button already has handler attached, skipping');
  } else {
    console.warn('[MODAL] No button found to attach handler to');
  }
}

// Try to attach on load
console.log('[MODAL] Script loaded, document.readyState:', document.readyState);
if (document.readyState === 'loading') {
  console.log('[MODAL] Waiting for DOMContentLoaded');
  document.addEventListener('DOMContentLoaded', attachDirectHandler);
} else {
  console.log('[MODAL] DOM already loaded, attaching handler now');
  attachDirectHandler();
}

class ShCheckoutConfirmationModal extends HTMLElement {
  constructor() {
    super();
    this.overlay = null;
    this.content = null;
    this.showButton = null;
    this.hideButton = null;
    this.confirmButton = null;
  }

  connectedCallback() {
    console.log('[MODAL] Custom element connectedCallback');
    // Use setTimeout to ensure DOM is fully ready
    setTimeout(() => {
      console.log('[MODAL] Initializing modal element');
      this.overlay = this.querySelector('.sh-ccm__overlay');
      this.content = this.querySelector('.sh-ccm__content');
      this.showButton = document.querySelector('.js-show-checkout-modal');
      this.hideButton = this.querySelector('.js-hide-checkout-modal');
      this.confirmButton = this.querySelector('.js-checkout-confirm');

      console.log('[MODAL] Elements found:', {
        overlay: this.overlay,
        content: this.content,
        showButton: this.showButton,
        hideButton: this.hideButton,
        confirmButton: this.confirmButton
      });

      // Hide modal by default
      this.hideModal();

      // Initialize event handlers
      this.init();
    }, 0);
  }

  init() {
    console.log('[MODAL] init called - setting up global Escape key handler');

    // Hide modal on escape key (global handler)
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isModalVisible()) {
        console.log('[MODAL] Escape key pressed, hiding modal');
        this.hideModal();
      }
    });

    // All other event handlers are managed by attachModalEventHandlers()
    // which is called each time showModal() is invoked to handle fresh DOM elements
  }

  showModal() {
    console.log('[MODAL] showModal called');

    // CRITICAL: Re-query elements every time to account for Section Rendering API updates
    this.overlay = this.querySelector('.sh-ccm__overlay');
    this.content = this.querySelector('.sh-ccm__content');
    this.hideButton = this.querySelector('.js-hide-checkout-modal');
    this.confirmButton = this.querySelector('.js-checkout-confirm');

    console.log('[MODAL] Fresh query - overlay:', this.overlay);
    console.log('[MODAL] Fresh query - content:', this.content);
    console.log('[MODAL] Fresh query - hideButton:', this.hideButton);
    console.log('[MODAL] Fresh query - confirmButton:', this.confirmButton);

    if (this.overlay && this.content) {
      console.log('[MODAL] Showing modal - overlay and content found');

      // CRITICAL: Re-attach event handlers to fresh elements
      this.attachModalEventHandlers();

      // Use !important to prevent Section Rendering API from overriding
      this.overlay.setAttribute('style', 'display: block !important');
      this.content.setAttribute('style', 'display: grid !important');
      document.body.style.overflow = 'hidden';

      // Check computed styles and position
      const overlayStyles = window.getComputedStyle(this.overlay);
      const contentStyles = window.getComputedStyle(this.content);
      console.log('[MODAL] Overlay computed display:', overlayStyles.display);
      console.log('[MODAL] Overlay computed z-index:', overlayStyles.zIndex);
      console.log('[MODAL] Overlay computed visibility:', overlayStyles.visibility);
      console.log('[MODAL] Content computed display:', contentStyles.display);
      console.log('[MODAL] Content computed z-index:', contentStyles.zIndex);
      console.log('[MODAL] Content computed visibility:', contentStyles.visibility);
      console.log('[MODAL] Modal shown successfully');

      // Check if modal stays visible
      setTimeout(() => {
        console.log('[MODAL] After 100ms - overlay still exists:', !!this.querySelector('.sh-ccm__overlay'));
        console.log('[MODAL] After 100ms - overlay display:', this.overlay?.style?.display);
        console.log('[MODAL] After 100ms - content display:', this.content?.style?.display);
      }, 100);
    } else {
      console.error('[MODAL] Could not find overlay or content elements!');
      console.error('[MODAL] This usually means there are no pre-order items in the cart');
      console.error('[MODAL] Check sections/sh-checkout-confirmation-modal.liquid condition');
    }
  }

  attachModalEventHandlers() {
    console.log('[MODAL] Attaching modal event handlers');

    // Remove old listeners by cloning and replacing (cleanest way to remove all listeners)
    if (this.hideButton) {
      const newHideButton = this.hideButton.cloneNode(true);
      this.hideButton.parentNode.replaceChild(newHideButton, this.hideButton);
      this.hideButton = newHideButton;

      this.hideButton.addEventListener('click', () => {
        console.log('[MODAL] Hide button clicked');
        this.hideModal();
      });
      console.log('[MODAL] Hide button handler attached');
    }

    if (this.overlay) {
      const newOverlay = this.overlay.cloneNode(true);
      this.overlay.parentNode.replaceChild(newOverlay, this.overlay);
      this.overlay = newOverlay;

      this.overlay.addEventListener('click', (e) => {
        console.log('[MODAL] Overlay clicked, target:', e.target);
        if (e.target === this.overlay) {
          console.log('[MODAL] Overlay itself clicked (not a child), hiding modal');
          this.hideModal();
        }
      });
      console.log('[MODAL] Overlay handler attached');
    }

    // Re-query all elements after overlay replacement (since overlay clone replaces all children)
    this.content = this.querySelector('.sh-ccm__content');
    this.hideButton = this.querySelector('.js-hide-checkout-modal');
    this.confirmButton = this.querySelector('.js-checkout-confirm');

    // Re-attach hide button handler after overlay clone
    if (this.hideButton) {
      this.hideButton.addEventListener('click', () => {
        console.log('[MODAL] Hide button clicked');
        this.hideModal();
      });
      console.log('[MODAL] Hide button handler re-attached after overlay clone');
    }

    // Attach confirm button handler
    if (this.confirmButton) {
      this.confirmButton.addEventListener('click', () => {
        console.log('[MODAL] Confirm button clicked - allowing native form submission');
        // No preventDefault() - let the browser submit the form naturally
        // The button has the correct form attribute set via Liquid template
      });
      console.log('[MODAL] Confirm button handler attached');
    } else {
      console.warn('[MODAL] Confirm button not found!');
    }
  }

  hideModal() {
    console.log('[MODAL] hideModal called');

    // Re-query elements in case they changed
    this.overlay = this.querySelector('.sh-ccm__overlay');
    this.content = this.querySelector('.sh-ccm__content');

    if (this.overlay && this.content) {
      console.log('[MODAL] Hiding modal');
      this.overlay.setAttribute('style', 'display: none !important');
      this.content.setAttribute('style', 'display: none !important');
      document.body.style.overflow = ''; // Restore scrolling
      console.log('[MODAL] Modal hidden');
    } else {
      console.warn('[MODAL] Cannot hide modal - overlay or content missing');
    }
  }

  isModalVisible() {
    // Re-query to check current state
    const overlay = this.querySelector('.sh-ccm__overlay');
    return overlay && overlay.style.display === 'block';
  }
}

// Register the custom element
customElements.define('sh-checkout-confirmation-modal', ShCheckoutConfirmationModal);
console.log('[MODAL] Custom element registered');

// Listen for cart updates and re-attach handlers after DOM updates
if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  console.log('[MODAL] Setting up cartUpdate subscription');
  subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
    console.log('[MODAL] cartUpdate event received:', data);
    // After cart updates, the button has been re-rendered via Section Rendering API
    // Re-attach the direct handler to the new button element
    setTimeout(() => {
      console.log('[MODAL] Re-attaching handler after cart update');
      attachDirectHandler();
    }, 50);
  });
  console.log('[MODAL] cartUpdate subscription established');
} else {
  console.warn('[MODAL] subscribe or PUB_SUB_EVENTS not available');
}

// Debug: Log ALL clicks on the document to track button clicks
document.addEventListener('click', (e) => {
  const checkoutButton = e.target.closest('.js-show-checkout-modal');
  if (checkoutButton) {
    console.log('[MODAL DEBUG] Checkout button clicked detected!', {
      target: e.target,
      button: checkoutButton,
      hasAttribute: checkoutButton.hasAttribute('data-modal-attached'),
      timestamp: new Date().toISOString()
    });
  }
}, true);